import StyledSvgServiceIcon, { TStyledSvgServiceIcon } from "../StyledSvgServiceIcon";

export const HistoryCalendarIcon: React.FC<TStyledSvgServiceIcon> = ({ active = false, ...props }) => {
  return (
    <StyledSvgServiceIcon {...props} active={active} viewBox="-50 120 400 400" version="1.1" id="Layer_1">
      <svg width="33" height="28" viewBox="0 0 33 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_260_152)">
          <path
            d="M28.04 4.20996H4C2.34 4.20996 1 5.54996 1 7.20996V23.21C1 24.87 2.34 26.21 4 26.21H28.04C29.7 26.21 31.04 24.87 31.04 23.21V7.20996C31.04 5.54996 29.7 4.20996 28.04 4.20996Z"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path d="M1 11H31.04" strokeWidth="2" strokeMiterlimit="10" />
          <path d="M6.99001 4.21V1" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
          <path d="M25.03 4.21V1" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
        </g>
        <defs>
          <clipPath id="clip0_260_152">
            <rect width="32.04" height="27.21" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </StyledSvgServiceIcon>
  );
};
